import React from 'react';
import styled from 'styled-components';

const ExternalLink = ({ href, ...props }) => {
    const StyledLink = styled.a`
        text-decoration: none;
        color: ${props => props.theme.palette.secondary[700]};
        border-bottom: 1px solid transparent;
        &:visited {
            border-bottom: 1px solid transparent;
            color: ${props => props.theme.palette.secondary[700]};
         }
        &:focus,
        &:hover {
            border-bottom: 1px dashed  ${props => props.theme.palette.secondary[700]};
        }
        &:active {
            border-bottom: 1px solid ${props => props.theme.palette.secondary[500]};
            color: ${props => props.theme.palette.secondary[500]};
        }
    `;

    return (
        <StyledLink href={href} {...props} />
    );
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink.js